import React, { useContext, useCallback } from 'react';
import messages from '../messages';
import { useSelector } from 'react-redux';
import Global from '../../../../../../src/store/global-selectors';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { GuidService } from 'ui-components/services/guid-service';
import { getNewAllocationRule, getNewTagsFilter, EDITOR_TYPE_TAG } from '../rule-helper';
import { AllocationRulesContext } from '../context';

const AddTagRule = () => {
  const { allocationRules, allocationStrategyId, filterSets, setSavedFiltersSets, setAllocationRules, setRuleIdInEdit, sellerTags } =
    useContext(AllocationRulesContext);

  const tags = useSelector(Global.selectSellerTags);
  const defaultTagId = tags.length ? tags[0].tagId : undefined;

  const createTagsRule = useCallback(() => {
    const orderFilterSetId = GuidService.newGuid();
    const tagsFilter = getNewTagsFilter(defaultTagId, orderFilterSetId);
    setSavedFiltersSets({
      ...filterSets,
      [orderFilterSetId]: tagsFilter,
    });
    const newRule = getNewAllocationRule(EDITOR_TYPE_TAG, allocationStrategyId, orderFilterSetId, allocationRules.length + 1);
    setAllocationRules([...allocationRules, newRule]);
    setRuleIdInEdit(newRule.allocationRuleId);
  }, [allocationRules, setRuleIdInEdit, setAllocationRules, filterSets, setSavedFiltersSets, allocationStrategyId, defaultTagId]);

  return (
    <DropdownMenuItem disabled={!sellerTags.length} onClick={createTagsRule}>
      <FormattedMessage {...messages.allocationStrategiesAddTagRule} />
    </DropdownMenuItem>
  );
};

export default AddTagRule;
